module.exports = __webpack_public_path__ + "img/pc_banner_cooperation.e6417043.jpeg";